import React, { FC } from 'react';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';

export enum LinkTextSize {
  small = 'qred-text-small',
  medium = 'qred-text-medium',
  large = 'qred-text-large',
}
export interface ILink {
  textBefore?: string;
  linkText?: string;
  linkUrl?: string;
  textAfter?: string;
  size?: LinkTextSize;
}

interface ILinkProps extends ILink, IBaseComponent {}

const Link: FC<ILinkProps> = ({
  linkText,
  linkUrl,
  textBefore,
  textAfter,
  size = LinkTextSize.medium,
}) => {
  return (
    <div className="qred-component">
      <div className="qred-group">
        <div className="qred-row">
          <p className={`qred-first ${size}`}>
            <span className="qred-first">
              {textBefore}
              {linkText && linkUrl && (
                <a href={linkUrl} target="_blank" rel="noreferrer">
                  {linkText}
                </a>
              )}
              {textAfter}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Link;
